// Packages
import React from "react";

import useComponents from "../../components";
import useLayouts from "../../layouts";

// Controllers
import useControllers from "../../../controllers";

const MFA = () => {
  const { Wrapper, TextFieldControlled, useButtons, Typography } = useComponents();
  const { PublicContentLayout } = useLayouts();
  const { DefaultButton } = useButtons();

  // Controllers
  const { useScreenHooks } = useControllers();
  const { useMFA } = useScreenHooks();
  const { control, handleSubmit, onSubmit, handleResend, isResending, getMaskedEmail, errors } = useMFA();

  return (
    <PublicContentLayout login>
      <Wrapper
        showLogo={true}
        description={""}
        maxWidth={"582px"}
        className="container"
        title={'Verificación de Seguridad'}
      >
        <div className="text-center mb-6">
          <Typography variant="body2" sx={{ mb: 2 }}>
            Hemos enviado un código de verificación de 8 caracteres a:
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {getMaskedEmail()}
          </Typography>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
          <TextFieldControlled
            id={"mfa_code"}
            name={"mfa_code"}
            label={"Código de verificación"}
            type={"text"}
            placeholder={"A1B2C3D4"}
            control={control}
            inputProps={{
              maxLength: 8,
              autoComplete: 'one-time-code',
            }}
          />

          <div className="text-center mt-6">
            <DefaultButton type="submit" color="secondary" fullWidth>
              Verificar y Continuar
            </DefaultButton>
          </div>
        </form>

        <div className="text-center mt-6">
          <Typography variant="body2">
            ¿No recibiste el código?{' '}
            <span
              onClick={handleResend}
              className={`cursor-pointer hover:text-primary underline ${isResending ? 'opacity-50 cursor-not-allowed' : ''}`}
              style={{
                fontWeight: 500,
                pointerEvents: isResending ? 'none' : 'auto'
              }}
            >
              {isResending ? 'Reenviando...' : 'Reenviar código'}
            </span>
          </Typography>
        </div>

        <div className="text-center mt-2">
          <Typography variant="caption" sx={{ fontSize: '12px' }}>
            Por seguridad, este código expirará en 10 minutos
          </Typography>
        </div>
      </Wrapper>
    </PublicContentLayout>
  );
};

export default MFA;
